import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CiCirclePlus } from "react-icons/ci";
import { FaFileAlt, FaDownload, FaTrash, FaImage, FaUser, FaListAlt, FaCalendarAlt, FaPlus, FaEdit, FaUpload } from "react-icons/fa";
import {
  downloadPrivacyFile,
  getFileDownload,
  editAplicationNumber,
  getApplicationUploadFile,
  deleteImg,
  getApplicationDetailList,
  getUploadFile,
  getApplicationAttorney,
  getApplicationStamp,
  createFileLink,
  deleteApplicationItem,
} from "JS/API";
import { catchError, commonModalSetting } from "JS/common";
import FloatingList from "Components/FloatingList";
import EditApplicationForm from "Components/EditApplicationForm";
import CommonModal from "Components/CommonModal";
import { detailPageStyles, listPageStyles } from "utils/designSystem";

const ApplicationInfoDetail = () => {
  const [info, setInfo] = useState({});
  const [alert, setAlert] = useState("");
  const [imageUrl, setImageUrl] = useState("");

  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });
  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    message: "",
    onConfirm: null,
  });
  const [newAgent, setNewAgent] = useState({
    agent_name: "",
    agent_company: "",
    agent_phone: "",
    agent_email: "",
  });

  const { id } = useParams();
  const navigate = useNavigate();
  let prevent = false;

  const [, setUserPk] = useState("");
  const [isMobile, setIsMobile] = useState(false);


  const [, setTaxInvoiceType] = useState();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  
  // 스타일 정의
  const styles = {
    container: {
      padding: '24px',
      paddingRight: isMobile ? '24px' : '380px', // FloatingList 공간 확보 (530px + 24px)
      backgroundColor: '#f1f5f9',
      minHeight: '100vh'
    },
    contentWrap: {
      width: '100%',
      maxWidth: '100%'
    },
    header: detailPageStyles.header,
    title: detailPageStyles.title,
    idBadge: detailPageStyles.idBadge,
    section: detailPageStyles.section,
    sectionHeader: {
      padding: '16px 24px',
      borderBottom: '1px solid #e2e8f0',
      backgroundColor: '#f8fafc'
    },
    sectionTitle: detailPageStyles.sectionTitle,
    sectionContent: detailPageStyles.sectionContent,
    tableWrapper: detailPageStyles.tableWrapper,
    table: detailPageStyles.table,
    th: detailPageStyles.th,
    td: detailPageStyles.td,
    tdTitle: detailPageStyles.tdTitle,
    input: {
      width: '100%',
      padding: '8px 12px',
      fontSize: '14px',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      backgroundColor: '#ffffff',
      color: '#1f2937',
      transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
      outline: 'none'
    },
    select: {
      width: '100%',
      padding: '8px 12px',
      fontSize: '14px',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      backgroundColor: '#ffffff',
      color: '#1f2937',
      outline: 'none'
    },
    button: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '10px 16px',
      backgroundColor: '#3b82f6',
      color: '#ffffff',
      border: 'none',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    },
    buttonSecondary: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '10px 16px',
      backgroundColor: '#6b7280',
      color: '#ffffff',
      border: 'none',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    },
    buttonDanger: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '10px 16px',
      backgroundColor: '#dc2626',
      color: '#ffffff',
      border: 'none',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    },
    imageContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px',
      padding: '24px'
    },
    imagePreview: {
      maxWidth: '400px',
      width: '100%',
      height: 'auto',
      borderRadius: '8px',
      border: '1px solid #e2e8f0',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
    },
    productTag: {
      display: 'inline-block',
      padding: '4px 8px',
      margin: '2px',
      backgroundColor: '#f3f4f6',
      border: '1px solid #d1d5db',
      borderRadius: '4px',
      fontSize: '12px',
      color: '#374151'
    },
    productTagNonRegistered: {
      backgroundColor: '#fef2f2',
      borderColor: '#fecaca',
      color: '#dc2626'
    },
    productContainer: {
      marginTop: '8px'
    },
    productGroup: {
      marginBottom: '16px'
    },
    productLabel: {
      fontWeight: '600',
      marginBottom: '8px',
      display: 'block'
    },
    productLabelRegistered: {
      color: '#059669'
    },
    productLabelNonRegistered: {
      color: '#dc2626'
    },
    productTags: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '4px',
      alignItems: 'center'
    },
    addButton: {
      width: '100%',
      height: '50px',
      border: '2px dashed #d1d5db',
      marginTop: '20px',
      borderRadius: '10px',
      textAlign: 'center',
      alignContent: 'center',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      backgroundColor: '#f9fafb',
      color: '#6b7280',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease'
    },
    buttonGroup: {
      display: 'flex',
      gap: '12px',
      flexWrap: 'wrap',
      marginTop: '16px'
    },
    fileUploadContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      flexWrap: 'wrap'
    },
    fileInfo: {
      fontSize: '12px',
      color: '#6b7280',
      marginTop: '4px',
      fontStyle: 'italic'
    },
    urlBox: {
      cursor: 'pointer',
      color: '#3b82f6',
      textDecoration: 'underline',
      marginTop: '10px',
      padding: '8px 12px',
      backgroundColor: '#eff6ff',
      borderRadius: '6px',
      border: '1px solid #bfdbfe'
    },
    checkboxGroup: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '16px',
      marginBottom: '16px'
    },
    checkboxLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '14px',
      color: '#374151',
      cursor: 'pointer'
    },
    checkbox: listPageStyles.checkbox,
    submitButton: {
      width: '100%',
      fontSize: '18px',
      fontWeight: '600',
      padding: '16px',
      marginTop: '24px',
      backgroundColor: '#10b981',
      color: '#ffffff',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    }
  };



  // 초기 데이터 로드
  useEffect(() => {
    if (id) {
      getDetail();
    }
  }, [id]);

  useEffect(() => {
    if (info?.tax_invoice_type) {
      setTaxInvoiceType(info.tax_invoice_type);
    }
  }, [info?.tax_invoice_type]);

  // API에서 가져온 대리인 정보를 폼에 설정
  useEffect(() => {
    if (
      info?.agent_name ||
      info?.agent_company ||
      info?.agent_number ||
      info?.agent_email
    ) {
      setNewAgent({
        agent_name: info.agent_name || "",
        agent_company: info.agent_company || "정상특허법률사무소",
        agent_phone: info.agent_number || "",
        agent_email: info.agent_email || "",
      });
    }
  }, [info]);

  // 대리인 정보 폼 입력 핸들러
  const handleAgentInputChange = (e) => {
    const { name, value } = e.target;
    setNewAgent((prev) => ({ ...prev, [name]: value }));
  };

  // 상세 정보 조회
  const [originalFileName, setOriginalFileName] = useState("");
  const [fileName, setFileName] = useState("");
  const [imagePath, setImagePath] = useState("");
  const [, setUploadComplete] = useState(false);
  const [initialProduct, setInitialProduct] = useState([]);
  const [markName, setMarkName] = useState("");

  const [applicantName, setApplicantName] = useState("");
  const [customerNumber, setCustomerNumber] = useState("");
  const [applyType, setApplyType] = useState("");
  const [priorityReview, setPrioriotyReview] = useState("");
  const [, setPrioriotyReviewNumber] = useState("");

  const keyTranslations = {
    NORMAL: "일반출원",
    SEARCH: "조사출원",
    FAST: "신속출원",
    FASTSEARCH: "신속조사출원",
  };


  const getDetail = async () => {
    if (prevent) return;
    prevent = true;
    setTimeout(() => (prevent = false), 200);

    try {
      const result = await getApplicationDetailList(id);
      console.log("API 응답 원본:", result);

      if (typeof result === "object" && result.data) {
        setInfo(result?.data);
        setUserPk(result?.data?.user_pk);
        setOriginalFileName(result?.data?.image_original_filename);
        setFileName(result?.data?.image_filename);
        setImagePath(result?.data.image_path);
        setMarkName(result?.data?.mark_name);
        setCustomerNumber(result?.data?.patent_customer_number);
        setApplicantName(result?.data?.applicant_name);
        setApplyType(result?.data?.apply_type);
        setPrioriotyReview(result?.data?.priority_review_yn);
        setPrioriotyReviewNumber(result?.data?.review_number);
        setInitialProduct(
          result?.data?.products?.reduce(
            (acc, { mark_class, product_name }) => {
              const found = acc.find((item) => item.mark_class === mark_class);
              if (found) {
                found.product_name.push(product_name);
              } else {
                acc.push({ mark_class, product_name: [product_name] });
              }
              return acc;
            },
            []
          )
        );
        // 이미지 로드
        if (result.data.image_filename && result.data.image_original_filename) {
          try {
            const url = await fetchUploadedImage(
              result.data.image_filename,
              result.data.image_original_filename
            );
            setImageUrl(url);
          } catch (error) {
            console.error("이미지 URL 가져오기 오류:", error);
          }
        }

        if (result.data) {
          const applicationInfo = {
            id: result.data.id,
            application_number: result.data.application_number || "",
            application_date: result.data.application_date || "",
            status: result.data.status || "",
            internal_status: result.data.internal_status || "",
            files: result.data.files || [],
          };

          setMergedResult([applicationInfo]);
        }
      } else {
        return await catchError(result, navigate, setAlertBox, setAlert);
      }
    } catch (error) {
      console.error("상세 정보 조회 오류:", error);
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "데이터를 불러오는 중 오류가 발생했습니다."
      );
    } finally {
      prevent = false;
    }
  };

  const [editTarget, setEditTarget] = useState(null);

  const handleDeleteProduct = async (targetMarkClass) => {
    if (!window.confirm(`${targetMarkClass}류를 삭제하시겠습니까?`)) return;

    const paddedMarkClass = targetMarkClass.padStart(2, "0");

    try {
      await deleteApplicationItem(id, {
        mark_class: paddedMarkClass,
      });

      setInitialProduct((prev) =>
        prev.filter((product) => product.mark_class !== targetMarkClass)
      );

      alert("삭제되었습니다.");
    } catch (err) {
      console.error("삭제 실패:", err);
      alert("삭제 중 오류가 발생했습니다.");
    }
  };

  // 도장 다운로드 핸들러
  const handleStampGeneration = async () => {
    try {
      const response = await getApplicationStamp(id);
      const blob = new Blob([response.data], {
        type: response.headers["content-type"] || "image/jpeg",
      });

      const filename = `도장_${applicantName}.jpg`;

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error("도장 생성 오류:", error);
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "도장 생성 중 오류가 발생했습니다."
      );
    }
  };


  // 위임장 다운로드 핸들러
  const handleAttorneyGeneration = async () => {
    try {
      const response = await getApplicationAttorney(id);

      const contentType = response.headers["content-type"];
      const isJson = contentType && contentType.includes("application/json");

      if (isJson) {
        const text = await response.data.text();
        const errorJson = JSON.parse(text);
        throw new Error(errorJson.detail || "알 수 없는 오류");
      }

      // .docx용 MIME 타입
      const blob = new Blob([response.data], {
        type:
          contentType ||
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      // ✅ 파일명 지정 (예: 위임장_홍길동.docx)
      const filename = `위임장_${applicantName}.docx`;

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error("위임장 생성 오류:", error);

      if (error.response?.status === 422) {
        commonModalSetting(
          setAlertBox,
          true,
          "alert",
          "특허고객번호가 입력되지 않았습니다."
        );
      } else {
        commonModalSetting(
          setAlertBox,
          true,
          "alert",
          "위임장 생성 중 오류가 발생했습니다."
        );
      }
    }
  };


  // 상품 정보 렌더링 함수 수정
 const renderDetails = () => {
    if (!info?.products || info.products.length === 0) {
      return (
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <h5 style={styles.sectionTitle}>
              <FaListAlt />
              상품/업종 정보
            </h5>
          </div>
          <div style={styles.sectionContent}>
            <div style={styles.tableWrapper}>
              <table style={styles.table}>
                <thead>
                  <tr>
                  <th style={{ ...styles.th, width: '20%' }}>상품 분류</th>
                    <th style={styles.th}>등록 상품</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{...styles.td, textAlign: 'center'}} colSpan="2">
                      상품 정보가 없습니다.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      );
    }

    return initialProduct?.map(({ mark_class, product_name }) => {
      const official = product_name.filter((_, i) =>
        info.products.some(
          (p) =>
            p.mark_class === mark_class &&
            p.similar_code &&
            p.product_name === product_name[i]
        )
      );
      const unofficial = product_name.filter((_, i) =>
        info.products.some(
          (p) =>
            p.mark_class === mark_class &&
            !p.similar_code &&
            p.product_name === product_name[i]
        )
      );

      return (
        <div key={mark_class} style={styles.section}>
          <div style={styles.sectionHeader}>
            <h5 style={styles.sectionTitle}>
              <FaListAlt />
              {mark_class}류 상품 정보 ({product_name?.length || 0}개)
            </h5>
          </div>
          <div style={styles.sectionContent}>
            <div style={styles.tableWrapper}>
              <table style={styles.table}>
                <thead>
                  <tr>
                  <th style={{ ...styles.th, width: '20%' }}>상품분류</th>
                    <th style={styles.th}>등록 상품</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={styles.td}>{mark_class}류</td>
                    <td style={styles.td}>
                      <div style={styles.productContainer}>
                        {official.length > 0 && (
                          <div style={styles.productGroup}>
                            <span style={{...styles.productLabel, ...styles.productLabelRegistered}}>
                              고시 상품 ({official.length})
                            </span>
                            <div style={styles.productTags}>
                              {official.map((name, index) => {
                                const matched = info.products.find(
                                  (p) =>
                                    p.mark_class === mark_class &&
                                    p.product_name === name &&
                                    p.similar_code
                                );

                                return (
                                  <div key={`official-${index}`} style={styles.productTag}>
                                    <div>{name}</div>
                                    {matched?.similar_code && (
                                      <div style={{
                                        fontSize: '11px',
                                        color: '#666',
                                        fontWeight: '600',
                                        marginTop: '2px'
                                      }}>
                                        {matched.similar_code}
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                        {unofficial.length > 0 && (
                          <div style={styles.productGroup}>
                            <span style={{...styles.productLabel, ...styles.productLabelNonRegistered}}>
                              비고시 상품 ({unofficial.length})
                            </span>
                            <div style={styles.productTags}>
                              {unofficial.map((name, index) => (
                                <div
                                  key={`unofficial-${index}`}
                                  style={{...styles.productTag, ...styles.productTagNonRegistered}}
                                >
                                  {name}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style={styles.buttonGroup}>
              <button
                style={styles.button}
                onClick={() => {
                  setEditTarget({ mark_class, product_name });
                  setEnterFloatSideBar(true);
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
              >
                <FaEdit />
                수정
              </button>
              <button
                style={styles.buttonDanger}
                onClick={() => handleDeleteProduct(mark_class)}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#b91c1c'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#dc2626'}
              >
                <FaTrash />
                삭제
              </button>
            </div>
          </div>
        </div>
      );
    });
  };

  const handleAddProduct = (newProduct) => {
    setInitialProduct((prev) => [...prev, newProduct]);
  };

  // 개인정보 파일 다운로드 함수
  const handleDownloadPrivacyFile = async (fileName, originalFileName) => {
    try {
      const blob = await downloadPrivacyFile(fileName, originalFileName);

      if (!(blob instanceof Blob)) {
        throw new Error("Response is not a Blob");
      }

      // 파일 다운로드
      const url = window.URL.createObjectURL(blob); // 임시 파일 다운로드 링크 생성
      const a = document.createElement("a"); // 링크 요소 생성
      a.href = url; // 링크 요소의 href 속성 설정
      a.download = originalFileName; // 링크 요소의 download 속성 설정
      document.body.appendChild(a); // 링크 요소를 문서에 추가
      a.click(); // 링크 요소 클릭
      window.URL.revokeObjectURL(url); // 링크 요소 제거
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading privacy file:", error);
      // 에러 처리 (예: 알림 표시)
    }
  };

  // 원본 이미지 다운로드 받기
  const handleImgDownload = async () => {
    if (!info?.image_filename || !info?.image_original_filename) {
      alert("다운로드할 이미지가 없습니다.");
      return;
    }

    try {
      // fetchUploadedImage → base64 data:image/... 형식 반환
      const dataUrl = await fetchUploadedImage(
        info.image_filename,
        info.image_original_filename
      );

      if (!dataUrl) {
        alert("이미지 데이터를 불러오지 못했습니다.");
        return;
      }

      // data URL을 링크로 다운로드
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = info.image_original_filename || "original_mark.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("다운로드 실패:", error);
      alert("이미지 다운로드에 실패했습니다.");
    }
  };

  // 출원 정보 등록

  const [mergedResult, setMergedResult] = useState([]);

  const handleEditApplicationNumber = async (targetId) => {
    try {
      if (!targetId && mergedResult.length > 0) {
        targetId = mergedResult[0].id;
      }

      if (!targetId) {
        commonModalSetting(
          setAlertBox,
          true,
          "alert",
          "수정할 데이터가 없습니다."
        );
        return;
      }

      const target = mergedResult.find((item) => item.id === targetId);
      if (!target) {
        commonModalSetting(
          setAlertBox,
          true,
          "alert",
          "해당 데이터를 찾을 수 없습니다."
        );
        return;
      }

      const rawCustomerNumber = customerNumber.replace(/-/g, "");

      const updatedData = {
        // 출원 정보
        application_number: target.application_number?.replace(/-/g, "") || "",
        application_date: target.application_date || "",
        status: target.status || "",
        mark_name: markName,
        image_original_filename: originalFileName,
        image_filename: fileName,
        image_path: imagePath,
        patent_customer_number: rawCustomerNumber,
        applicant_name: applicantName,
        agent_name: newAgent.agent_name || "",
        agent_company: newAgent.agent_company || "정상특허법률사무소",
        agent_number: newAgent.agent_phone || "",
        agent_email: newAgent.agent_email || "",
        priority_review_yn: priorityReview
        // products: initialProduct || [],
      };

      const response = await editAplicationNumber(targetId, updatedData);

      if (response?.data?.success === true) {
        commonModalSetting(setAlertBox, true, "alert", "변경되었습니다.");
        getDetail();
      } else {
        commonModalSetting(setAlertBox, true, "alert", "다시 시도해주세요.");
      }
    } catch (error) {
      console.error("출원 정보 수정 중 오류 발생:", error);
      commonModalSetting(setAlertBox, true, "alert", "다시 시도해주세요.");
    }
  };

  const handleChange = (index, field, value) => {
    setMergedResult((prev) =>
      prev?.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };

  const handleDeleteFile = async (fileId) => {
    if (!fileId) return;
  
    try {
      await deleteImg(fileId);
      
      // 삭제 후 서버에서 최신 데이터를 다시 가져와서 상태 업데이트
      await getDetail();
  
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "파일이 삭제되었습니다."
      );
    } catch (error) {
      console.error("파일 삭제 실패:", error);
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "파일 삭제에 실패했습니다."
      );
    }
  };
  
  const fileInputRefs = useRef([]);
  // selectedFileNames 상태 제거 - 더 이상 필요 없음
  
  const handleFileUpload = async (index, fileType) => {
    const input = fileInputRefs.current[index];
    const targetId = mergedResult[0]?.id;
  
    console.log("파일 업로드 시작:", { index, fileType, targetId });
  
    if (!input?.files?.[0]) {
      console.log("파일이 선택되지 않음");
      return;
    }
  
    const file = input.files[0];
    console.log("선택된 파일:", file.name);
    
    const formData = new FormData();
    formData.append("file_type", fileType);
    formData.append("file", file);
  
    try {
      console.log("업로드 API 호출 시작");
      const response = await getApplicationUploadFile(targetId, formData);
      console.log("업로드 API 응답:", response);
      console.log("응답 데이터:", response.data);
      
      // 조건을 수정: response.data가 존재하면 성공으로 간주
      if (response?.data) {
        console.log("업로드 성공, getDetail 호출 시작");
        // 업로드 후 서버에서 최신 데이터를 다시 가져와서 상태 업데이트
        await getDetail();
        console.log("getDetail 호출 완료");
  
        commonModalSetting(
          setAlertBox,
          true,
          "alert",
          "파일이 업로드되었습니다."
        );
      } else {
        console.log("업로드 응답 데이터가 예상과 다름:", response);
      }
    } catch (error) {
      console.error("파일 업로드 실패:", error);
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "파일 업로드에 실패했습니다."
      );
    }
  };
  
  useEffect(() => {
    const etcFiles =
      mergedResult[0]?.files?.filter((f) => f.file_type === "etc") || [];
    if (etcFiles.length > 0) {
      setEtcFileRows(Array.from({ length: etcFiles.length }, (_, i) => i));
    }
  }, [mergedResult]);
  
  const [etcFileRows, setEtcFileRows] = useState([]);
  
  const getFileByType = (type, etcIndex = 0) => {
    if (type !== "etc") {
      return mergedResult[0]?.files?.find((file) => file.file_type === type);
    }
    const etcFiles = mergedResult[0]?.files?.filter((file) => file.file_type === "etc") || [];
    return etcFiles[etcIndex];
  };
  
  const renderFileUploadRow = (index, fileType, label, etcIndex = 0) => {
    const existingFile = getFileByType(fileType, etcIndex);
  
    return (
      <>
        <input
          type="file"
          ref={(el) => (fileInputRefs.current[index] = el)}
          style={{ display: "none" }}
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) {
              handleFileUpload(index, fileType);
            }
          }}
        />
  
        {existingFile ? (
          <div style={styles.fileUploadContainer}>
            <span style={{ fontSize: '14px', color: '#374151' }}>
              {existingFile.original_file_name}
            </span>
            <button
              style={styles.buttonDanger}
              onClick={() => handleDeleteFile(existingFile.id)}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#b91c1c'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#dc2626'}
            >
              <FaTrash />
              삭제
            </button>
            <button
              style={styles.button}
              onClick={() =>
                handleDownloadPrivacyFile(
                  existingFile.file_name,
                  existingFile.original_file_name
                )
              }
              onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
            >
              <FaDownload />
              다운로드
            </button>
          </div>
        ) : (
          <button 
            style={styles.button}
            onClick={() => fileInputRefs.current[index]?.click()}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
          >
            <FaUpload />
            파일 업로드
          </button>
        )}
      </>
    );
  };
  const [enterFloatSideBar, setEnterFloatSideBar] = useState(false);

  const handleUpdateProduct = (updated) => {
    setInitialProduct((prev) =>
      prev.map((item) =>
        item.mark_class === updated.mark_class ? updated : item
      )
    );
    setEnterFloatSideBar(false);
  };

  const fileInputRef = useRef(null);

  const handleImageChange = async (e) => {
    const file = e.target.files?.[0];
    if (file) {
      // 미리보기 설정
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageUrl(reader.result);
      };
      reader.readAsDataURL(file);

      // 서버 업로드 준비
      const formData = new FormData();
      formData.append("files", file, file.name);
      formData.append("file_type", "logo_agent");

      try {
        const result = await getUploadFile(formData);
        if (typeof result === "object") {
          const originalFileName = result?.data[0]?.original_file_name;
          const fileName = result?.data[0]?.filename;
          const path = result?.data[0]?.path;

          setOriginalFileName(originalFileName);
          setFileName(fileName);
          setImagePath(path);
          setUploadComplete(true);
        } else {
          setUploadComplete(false);
        }
      } catch (error) {
        console.error("원본 이미지 업로드 실패:", error);
        setUploadComplete(false);
      }
    }
  };

  useEffect(() => {
    if (customerNumber) {
      const formatted = formatCustomerNumber(customerNumber);
      setCustomerNumber(formatted);
    }
  }, [customerNumber]);

  const fetchUploadedImage = async (imageFileName, imageOriginalFileName) => {
    try {
      const response = await getFileDownload(
        imageFileName,
        imageOriginalFileName
      );
      const base64 = btoa(
        new Uint8Array(response.data).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        )
      );
      const mimeType = response.headers["content-type"];
      return `data:${mimeType};base64,${base64}`;
    } catch (error) {
      console.error("이미지 불러오기 실패:", error);
      return null;
    }
  };

  const formatApplicationNumber = (value) => {
    if (!value) return "";
    const onlyDigits = value.replace(/\D/g, "").slice(0, 13);

    if (onlyDigits.length <= 2) return onlyDigits;

    let formatted = onlyDigits.slice(0, 2) + "-" + onlyDigits.slice(2);
    if (onlyDigits.length > 6) {
      formatted = formatted.slice(0, 7) + "-" + formatted.slice(7);
    }

    return formatted;
  };

  const formatCustomerNumber = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 13);
    const parts = [];

    if (digits.length > 0) parts.push(digits.slice(0, 1)); // 1
    if (digits.length > 1) parts.push(digits.slice(1, 5)); // 1111
    if (digits.length > 5) parts.push(digits.slice(5, 11)); // 111111
    if (digits.length > 11) parts.push(digits.slice(11, 13)); // 1~2자리

    return parts.filter((part) => part).join("-");
  };

  const handleCustomerNumberChange = (e) => {
    const raw = e.target.value.replace(/\D/g, "");
    const formatted = formatCustomerNumber(raw);
    setCustomerNumber(formatted);
  };

  const [selectedFiles, setSelectedFiles] = useState([]);

  const options = [
    { label: "사업자등록증", value: "biz_license" },
    { label: "인감증명서", value: "stamp_certificate" },
    { label: "인감", value: "stamp" },
    { label: "기타", value: "etc" },
  ];

  const handleCheckboxChange = (value) => {
    setSelectedFiles((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  const [tempUrl, setTempUrl] = useState("");
  // 파일 업로드 url
  const getUrlFunc = async () => {
    if (selectedFiles.length === 0) {
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "요청할 서류를 선택해주세요."
      );
      return;
    }
    try {
      const data = {
        user_pk: info.user_pk,
        require_files: selectedFiles,
        expires_in_days: 3,
      };
      const res = await createFileLink(data);
      setTempUrl(res?.data?.upload_url);
    } catch (err) {
      alert("업로드 실패");
      console.error(err);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.contentWrap}>
        {/* 헤더 */}
        <div style={styles.header}>
          <h1 style={styles.title}>
            <FaFileAlt />
            APPLICATION-INFO-DETAIL
            <span style={styles.idBadge}>ID: {id}</span>
          </h1>
        </div>

        {/* 추가 서류 요청 */}
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <h5 style={styles.sectionTitle}>
              <FaFileAlt />
              추가 서류 요청
            </h5>
          </div>
          <div style={styles.sectionContent}>
            <div style={styles.checkboxGroup}>
              {options.map((opt) => (
                <label key={opt.value} style={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    style={styles.checkbox}
                    value={opt.value}
                    checked={selectedFiles.includes(opt.value)}
                    onChange={() => handleCheckboxChange(opt.value)}
                  />
                  {opt.label}
                </label>
              ))}
            </div>
            <button 
              style={styles.button} 
              onClick={getUrlFunc}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
            >
              <FaPlus />
              URL 생성하기
            </button>
            {tempUrl && (
              <div
                style={styles.urlBox}
                onClick={() => {
                  navigator.clipboard.writeText(tempUrl);
                  setConfirmModal({
                    isOpen: true,
                    message: "URL이 복사되었습니다.",
                    onConfirm: () => setConfirmModal({ isOpen: false }),
                  });
                }}
              >
                {tempUrl}
              </div>
            )}
          </div>
        </div>

        {/* 상표 이미지 */}
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <h5 style={styles.sectionTitle}>
              <FaImage />
              상표 이미지
            </h5>
          </div>
          <div style={styles.sectionContent}>
            <div style={styles.tableWrapper}>
              <table style={styles.table}>
                <tbody>
                  <tr>
                    <td style={{...styles.td, ...styles.tdTitle}}>상표명</td>
                    <td style={styles.td}>
                      <input
                        style={styles.input}
                        type="text"
                        name="mark_name"
                        value={markName || ""}
                        onChange={(e) => setMarkName(e.target.value)}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#3b82f6';
                          e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#d1d5db';
                          e.target.style.boxShadow = 'none';
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style={styles.imageContainer}>
              {imageUrl && (
                <img
                  src={imageUrl}
                  alt="상표 이미지"
                  style={styles.imagePreview}
                />
              )}
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleImageChange}
              />
              <div style={styles.buttonGroup}>
                <button 
                  onClick={handleImgDownload} 
                  style={styles.button}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
                >
                  <FaDownload />
                  이미지 다운로드
                </button>
                <button 
                  onClick={() => fileInputRef.current.click()}
                  style={styles.buttonSecondary}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#4b5563'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#6b7280'}
                >
                  <FaEdit />
                  이미지 변경
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* 우선심사 여부 */}
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <h5 style={styles.sectionTitle}>
              <FaCalendarAlt />
              우선심사 여부
            </h5>
          </div>
          <div style={styles.sectionContent}>
            <div style={styles.tableWrapper}>
              <table style={styles.table}>
                <tbody>
                  <tr>
                    <td style={{...styles.td, ...styles.tdTitle}}>내부 참고용 우선심사 체크</td>
                    <td style={styles.td}>
                      <select
                        style={styles.select}
                        value={priorityReview}
                        onChange={(e) => setPrioriotyReview(e.target.value)}
                      >
                        <option value="">선택</option>
                        <option value="Y">우선심사</option>
                        <option value="N">방식심사</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td style={{...styles.td, ...styles.tdTitle}}>특허로 제출된 우선심사</td>
                    <td style={styles.td}>
                      <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <FaCalendarAlt size={12} />
                        {info?.patent_priority_review} &nbsp; | &nbsp; {info?.review_number}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* 상품/업종 정보 */}
        {renderDetails()}

        {/* 상품분류 추가 버튼 */}
        <div
          style={{
            ...styles.addButton,
            ...(isMobile && {
              '&:hover': {
                backgroundColor: '#f3f4f6',
                borderColor: '#9ca3af',
                color: '#374151'
              }
            })
          }}
          onClick={() => {
            setEditTarget(null);
            setEnterFloatSideBar(true);
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#f3f4f6';
            e.target.style.borderColor = '#9ca3af';
            e.target.style.color = '#374151';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#f9fafb';
            e.target.style.borderColor = '#d1d5db';
            e.target.style.color = '#6b7280';
          }}
        >
          <CiCirclePlus size={20} />
          상품분류 추가
        </div>

        {/* 출원 정보 */}
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <h5 style={styles.sectionTitle}>
              <FaFileAlt />
              출원 정보
            </h5>
          </div>
          <div style={styles.sectionContent}>
            <div style={styles.buttonGroup}>
              <button
                style={styles.button}
                onClick={handleAttorneyGeneration}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
              >
                <FaFileAlt />
                위임장 생성
              </button>
              <button
                style={styles.button}
                onClick={handleStampGeneration}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
              >
                <FaImage />
                도장 생성
              </button>
              <button
                style={styles.button}
                onClick={() =>
                  window.open("https://www.remove.bg/ko/upload", "_blank")
                }
                onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
              >
                <FaEdit />
                도장 누끼
              </button>
            </div>

            {mergedResult.length > 0 && (
              <div style={{ marginTop: '24px' }}>
                <div style={styles.tableWrapper}>
                  <table style={styles.table}>
                    <tbody>
                      <tr>
                        <td style={{...styles.td, ...styles.tdTitle}}>출원인</td>
                        <td style={styles.td}>
                          <input
                            style={styles.input}
                            type="text"
                            name="applicant_name"
                            value={applicantName}
                            onChange={(e) => setApplicantName(e.target.value)}
                            onFocus={(e) => {
                              e.target.style.borderColor = '#3b82f6';
                              e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = '#d1d5db';
                              e.target.style.boxShadow = 'none';
                            }}
                          />
                        </td>
                        <td style={{...styles.td, ...styles.tdTitle}}>특허고객번호</td>
                        <td style={styles.td}>
                          <input
                            style={styles.input}
                            type="text"
                            name="customer_number"
                            value={customerNumber}
                            onChange={handleCustomerNumberChange}
                            maxLength={17}
                            onFocus={(e) => {
                              e.target.style.borderColor = '#3b82f6';
                              e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = '#d1d5db';
                              e.target.style.boxShadow = 'none';
                            }}
                          />
                          <div style={styles.buttonGroup}>
                            <button
                              style={styles.buttonSecondary}
                              onClick={() =>
                                window.open(
                                  "https://www.patent.go.kr/smart/jsp/ka/prestep/codeapp/CodeAppView.do",
                                  "_blank"
                                )
                              }
                              onMouseEnter={(e) => e.target.style.backgroundColor = '#4b5563'}
                              onMouseLeave={(e) => e.target.style.backgroundColor = '#6b7280'}
                            >
                              특허고객번호 신청
                            </button>
                            <button
                              style={styles.buttonSecondary}
                              onClick={() =>
                                window.open(
                                  "https://www.patent.go.kr/smart/jsp/kiponet/mp/mpopenpatinfo/apagtinfo/ReadApAgtInfoInput.do",
                                  "_blank"
                                )
                              }
                              onMouseEnter={(e) => e.target.style.backgroundColor = '#4b5563'}
                              onMouseLeave={(e) => e.target.style.backgroundColor = '#6b7280'}
                            >
                              특허고객번호 확인
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style={{...styles.td, ...styles.tdTitle}}>출원 번호</td>
                        <td style={styles.td}>
                          <input
                            style={styles.input}
                            type="text"
                            name="application_number"
                            value={formatApplicationNumber(
                              mergedResult[0]?.application_number
                            )}
                            onChange={(e) => {
                              let value = e.target.value.replace(/\D/g, "");
                              if (value.length > 13) value = value.slice(0, 13);

                              let formatted = value;
                              if (value.length > 2) {
                                formatted =
                                  value.slice(0, 2) + "-" + value.slice(2);
                              }
                              if (value.length > 6) {
                                formatted =
                                  formatted.slice(0, 7) +
                                  "-" +
                                  formatted.slice(7);
                              }

                              handleChange(0, "application_number", formatted);
                            }}
                            onFocus={(e) => {
                              e.target.style.borderColor = '#3b82f6';
                              e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = '#d1d5db';
                              e.target.style.boxShadow = 'none';
                            }}
                          />
                        </td>
                        <td style={{...styles.td, ...styles.tdTitle}}>출원 일자</td>
                        <td style={styles.td}>
                          <input
                            style={styles.input}
                            type="date"
                            name="application_date"
                            value={mergedResult[0].application_date || ""}
                            onChange={(e) =>
                              handleChange(0, "application_date", e.target.value)
                            }
                            onFocus={(e) => {
                              e.target.style.borderColor = '#3b82f6';
                              e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = '#d1d5db';
                              e.target.style.boxShadow = 'none';
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{...styles.td, ...styles.tdTitle}}>상표 상태</td>
                        <td style={styles.td}>
                          <select
                            style={styles.select}
                            value={mergedResult[0].status || ""}
                            onChange={(e) =>
                              handleChange(0, "status", e.target.value)
                            }
                          >
                            <option value="all">선택</option>
                            <option value="출원 전">출원 전</option>
                            <option value="출원">출원</option>
                            <option value="등록">등록</option>
                            <option value="소멸">소멸</option>
                            <option value="포기">포기</option>
                            <option value="무효">무효</option>
                            <option value="취하">취하</option>
                            <option value="공고">공고</option>
                          </select>
                        </td>
                        <td style={{...styles.td, ...styles.tdTitle}}>출원 유형</td>
                        <td style={styles.td}>{keyTranslations[applyType]}</td>
                      </tr>
                      <tr>
                        <td style={{...styles.td, ...styles.tdTitle}}>출원서</td>
                        <td style={styles.td} colSpan="3">
                          {renderFileUploadRow(0, "application", "출원서")}
                          <div style={styles.fileInfo}>
                            파일 이름은 예: <strong>상표등록출원_{"{상표이름}"}_{"{출원인 이름}"}_{"{상표분류}"}</strong> 형식으로 해주세요.
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style={{...styles.td, ...styles.tdTitle}}>위임장</td>
                        <td style={styles.td} colSpan="3">
                          {renderFileUploadRow(1, "attorney", "위임장")}
                          <div style={styles.fileInfo}>
                            파일 이름은 예: <strong>위임장_{"{출원인 이름}"}</strong> 형식으로 해주세요.
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style={{...styles.td, ...styles.tdTitle}}>도장</td>
                        <td style={styles.td} colSpan="3">
                          {renderFileUploadRow(2, "stamp", "도장")}
                          <div style={styles.fileInfo}>
                            파일 이름은 예: <strong>도장_{"{출원인 이름}"}</strong> 형식으로 해주세요.
                          </div>
                        </td>
                      </tr>
                      {etcFileRows.map((_, i) => (
                        <tr key={`etc-${i}`}>
                          <td style={{...styles.td, ...styles.tdTitle}}>기타 서류 {i + 1}</td>
                          <td style={styles.td} colSpan="3">
                            {renderFileUploadRow(
                              3 + i,
                              "etc",
                              `기타 서류 ${i + 1}`,
                              i
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '20px',
                  marginTop: '20px',
                  padding: '16px',
                  backgroundColor: '#f8fafc',
                  borderRadius: '8px',
                  border: '1px solid #e2e8f0'
                }}>
                  <span style={{ fontSize: '14px', color: '#374151' }}>올려야 할 기타 서류가 있나요?</span>
                  <button
                    style={styles.button}
                    onClick={() =>
                      setEtcFileRows((prev) => [...prev, prev.length])
                    }
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
                  >
                    <FaPlus />
                    네
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* 대리인 정보 */}
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <h5 style={styles.sectionTitle}>
              <FaUser />
              대리인 정보
            </h5>
          </div>
          <div style={styles.sectionContent}>
            <div style={styles.tableWrapper}>
              <table style={styles.table}>
                <tbody>
                  <tr>
                    <td style={{...styles.td, ...styles.tdTitle}}>대리인명</td>
                    <td style={styles.td}>
                      <input
                        style={styles.input}
                        type="text"
                        name="agent_name"
                        value={newAgent.agent_name || info.agent_name || ""}
                        onChange={handleAgentInputChange}
                        placeholder="예) 홍길동"
                        onFocus={(e) => {
                          e.target.style.borderColor = '#3b82f6';
                          e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#d1d5db';
                          e.target.style.boxShadow = 'none';
                        }}
                      />
                    </td>
                    <td style={{...styles.td, ...styles.tdTitle}}>회사명</td>
                    <td style={styles.td}>정상특허법률사무소</td>
                  </tr>
                  <tr>
                    <td style={{...styles.td, ...styles.tdTitle}}>대리인 번호</td>
                    <td style={styles.td}>
                      <input
                        style={styles.input}
                        type="text"
                        name="agent_phone"
                        value={newAgent.agent_phone || info.agent_phone || ""}
                        onChange={handleAgentInputChange}
                        placeholder="예) 9-2010-001289-8"
                        onFocus={(e) => {
                          e.target.style.borderColor = '#3b82f6';
                          e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#d1d5db';
                          e.target.style.boxShadow = 'none';
                        }}
                      />
                    </td>
                    <td style={{...styles.td, ...styles.tdTitle}}>이메일</td>
                    <td style={styles.td}>
                      <input
                        style={styles.input}
                        type="text"
                        name="agent_email"
                        value={newAgent.agent_email || info.agent_email || ""}
                        onChange={handleAgentInputChange}
                        placeholder="예) example@agency.com"
                        onFocus={(e) => {
                          e.target.style.borderColor = '#3b82f6';
                          e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#d1d5db';
                          e.target.style.boxShadow = 'none';
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* 수정 버튼 */}
        <button
          style={styles.submitButton}
          onClick={() => {
            if (mergedResult.length > 0) {
              handleEditApplicationNumber(mergedResult[0].id);
            } else {
              commonModalSetting(
                setAlertBox,
                true,
                "alert",
                "수정할 데이터가 없습니다."
              );
            }
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#059669'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#10b981'}
        >
          수정
        </button>
      </div>

      {/* EditApplicationForm 모달 */}
      {enterFloatSideBar && (
        <EditApplicationForm
          setEnterFloatSideBar={setEnterFloatSideBar}
          editTarget={editTarget}
          onUpdateProduct={handleUpdateProduct}
          onAddProduct={handleAddProduct}
          usedMarkClasses={initialProduct.map((p) =>
            String(p.mark_class).padStart(2, "0")
          )}
          id={id}
          getDetail={getDetail}
        />
      )}

      {/* 공통 모달 */}
      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "logout") navigate("/");
            else return;
          }}
        />
      )}

      {/* 확인 모달 */}
      {confirmModal.isOpen && (
        <CommonModal
          setModal={setConfirmModal}
          modal={{
            mode: "alert",
            context: confirmModal.message,
            bool: true
          }}
          okFn={confirmModal.onConfirm}
        />
      )}

      {/* FloatingList */}
      <FloatingList
        type={"APPLICATION"}
        id={id}
      />

      {/* 반응형 스타일 */}
      <style>{`
        @media (max-width: 768px) {
          .table-wrapper {
            -webkit-overflow-scrolling: touch;
          }
          
          .table-wrapper::-webkit-scrollbar {
            height: 6px;
          }
          
          .table-wrapper::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 3px;
          }
          
          .table-wrapper::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 3px;
          }
        }
        
        input:focus, select:focus {
          outline: none !important;
        }
      `}</style>
    </div>
  );
};

export default ApplicationInfoDetail;